
import { Client } from './clientTypes';

export const serviceClients: Client[] = [
  { 
    id: 2, 
    name: "Cyracom", 
    logoPath: "/lovable-uploads/b5d8a003-ac9e-4a8f-a068-2b600c160677.png",
    altText: "Logo de Cyracom International, Inc."
  },
  { 
    id: 3, 
    name: "La Piedad", 
    logoPath: "/lovable-uploads/120ed171-f84d-45d6-9f6f-b678e87c59e1.png",
    altText: "Logo de La Piedad - Camposantos, Crematorios, Funerarias"
  },
  { 
    id: 6, 
    name: "TPC", 
    logoPath: "/lovable-uploads/550a58a2-6992-4a56-88f9-3f2e8158276e.png",
    altText: "Logo de TPC"
  },
  { 
    id: 7, 
    name: "AirPak", 
    logoPath: "/lovable-uploads/c90bde62-ca54-4edc-9f9a-d4c5ff4a5f98.png",
    altText: "Logo de AirPak"
  },
  { 
    id: 9, 
    name: "ASEBoston", 
    logoPath: "/lovable-uploads/a0bf7886-d39c-4dc6-ab9a-1e3afc1e9c8d.png",
    altText: "Logo de ASEBoston"
  },
  { 
    id: 11, 
    name: "Bill Gosling Outsourcing", 
    logoPath: "/lovable-uploads/3163c515-632f-42be-8cab-b553f9626977.png",
    altText: "Logo de Bill Gosling Outsourcing"
  },
  { 
    id: 12, 
    name: "Bimbo Global Services", 
    logoPath: "/lovable-uploads/703770c0-58c5-4711-a2e0-78d12afb6f56.png",
    altText: "Logo de Bimbo Global Services"
  },
  { 
    id: 17, 
    name: "Eagle", 
    logoPath: "/lovable-uploads/29db26c8-154a-4f99-adfb-2f3f24844572.png",
    altText: "Logo de Eagle"
  },
  { 
    id: 19, 
    name: "FLEX", 
    logoPath: "/lovable-uploads/b9f1c86b-6087-44e6-92f3-2efccd315d05.png",
    altText: "Logo de FLEX"
  },
  { 
    id: 28, 
    name: "Meditek", 
    logoPath: "/lovable-uploads/fa32aad9-c63d-4d2c-9046-fdd36e01e17c.png",
    altText: "Logo de Meditek - tecnología médica dental digital" 
  },
  { 
    id: 29, 
    name: "Nutricare", 
    logoPath: "/lovable-uploads/034e313e-afa3-4343-b405-9c459813b6de.png",
    altText: "Logo de Nutricare - Salud integral" 
  },
  { 
    id: 30, 
    name: "Soluciones Logísticas", 
    logoPath: "/lovable-uploads/00389ca2-0177-4a0f-bf71-b302407d167f.png",
    altText: "Logo de Soluciones Logísticas" 
  },
  { 
    id: 33, 
    name: "Search", 
    logoPath: "/lovable-uploads/28e999bf-7342-4428-9533-4c51e6012f90.png",
    altText: "Logo de Search - Human Factor Leaders" 
  },
  { 
    id: 34, 
    name: "Telecable", 
    logoPath: "/lovable-uploads/b9899021-53a3-4e55-8e3d-46418ba9aa70.png",
    altText: "Logo de Telecable" 
  },
  { 
    id: 35, 
    name: "Gas Tomza", 
    logoPath: "/lovable-uploads/83402e17-84a3-4ec5-9660-9f6a316773ca.png",
    altText: "Logo de Gas Tomza" 
  },
  { 
    id: 38, 
    name: "ASECCSS", 
    logoPath: "/lovable-uploads/f2117cc6-6f92-4b09-8ba7-76694bbf6f45.png",
    altText: "Logo de ASECCSS" 
  },
  { 
    id: 39, 
    name: "BDS RH", 
    logoPath: "/lovable-uploads/af2ea9c5-f1c3-411d-8f97-b66a034988f5.png",
    altText: "Logo de BDS RH" 
  },
];
